
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'CardTodo',
})
export default class CardTodo extends Vue {
    @Prop(Number) private id: number;
    @Prop(String) private title: string;
    @Prop(String) private description: string;
}
